module.exports = __webpack_public_path__ + "img/weiJingQunDao.24e371b7.png";